import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import miscHelper from 'general/helpers/miscHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogDriverAddView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogDriverAddView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const editMode = !!item;
  const { operatorList, operatorOptions } = useAgency();
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatar, setAvatar] = useState('');
  const [fullname, setFullname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [idCard, setIdCard] = useState('');
  const [discountType, setDiscountType] = useState('');
  const [discountRate, setDiscountRate] = useState(item ? item.discountRate * 100 : 0);
  useEffect(() => {
    if (item) {
      setAvatar(item.avatar);
      setFullname(item.fullname);
      setPhone(item.phone);
      setEmail(item.email);
      setIdCard(item.idCard ?? item.idCardNumber ?? '');
      setDiscountRate(item.discountRate * 100);
    }
  }, [item]);
  useEffect(() => {
    if (discountRate === 0) setDiscountType('STANDARD');
    else if (discountRate === 100) setDiscountType('FREE');
    else setDiscountType('DISCOUNT');
  }, [discountRate])
  useEffect(() => {
    if (discountType === 'STANDARD') setDiscountRate(0);
    else if (discountType === 'FREE') setDiscountRate(100);
  }, [discountType])
  const isValidIdCard =
    !Utils.isValid(idCard) || AppConfigs.regex.idCardNumber.test(idCard.toString());

  // MARK: ---- FUNCTIONS ----
  const handleSubmit = async () => {

    setReadyToValidate(true);
    if (
      !Utils.isValid(fullname) ||
      !Utils.isValid(email) ||
      !Utils.isValid(discountRate)
    ) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
      return;
    }

    if (Utils.isValid(phone) && !phone.match(AppConfigs.regex.phone)) {
      ToastHelper.showError('Số điện thoại không hợp lệ');
      return;
    }

    if (!email.match(AppConfigs.regex.email)) {
      ToastHelper.showError('Email không hợp lệ');
      return;
    }

    if (!isValidIdCard) {
      ToastHelper.showError('Số CCCD phải gồm đúng 12 số');
      return;
    }

    if (Utils.isValid(discountRate) && discountType === 'DISCOUNT') {
      if (discountRate <= 0) {
        ToastHelper.showError('Tỷ lệ chiết khấu phải lớn hơn 0');
        return;
      }
      if (discountRate >= 100) {
        ToastHelper.showError('Tỷ lệ chiết khấu phải nhỏ hơn 100');
        return;
      }
    }
    let params = {
      fullname,
      phone,
      email,
      idCardNumber: idCard,
      password: '123456',
      discountRate: discountRate / 100,
      operatorId: _.first(operatorList)?.operatorId,
    };
    if (avatarFile) {
      const res = await miscHelper.callApiUploadFile(avatarFile);
      if (_.isArray(res) && res.length > 0) {
        params.avatar = res[0].relativePath;
      }
    }
    params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
    // console.log({ params });
    setLoading(true);
    if (!editMode) {
      params.status = ChargeConstants.ChargeDriverStatus.NORMAL;
      const res = await ChargeHelper.API.Driver.requestAddDriver(params);
      if (_.isBoolean(res) && res) {
        ToastHelper.showSuccess('Thêm mới khách hàng thành công');
        onDone && onDone();
      } else if (_.isString(res)) {
        ToastHelper.showError(res);
      }
    } else {
      const res = await ChargeHelper.API.Driver.requestUpdateDriver(item.userId, params);
      if (_.isBoolean(res) && res) {
        ToastHelper.showSuccess('Chỉnh sửa thông tin khách hàng thành công');
        onDone && onDone();
      } else if (_.isString(res)) {
        ToastHelper.showError(res);
      }
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2 mt-4">
        {/* avatar */}
        <div className="col-12 mb-4 px-2">
          {UIHelper.buildFormLabel('Ảnh đại diện')}
          <div className="row m-0 p-0">
            <div className="col-lg-3 col-md-4 col-6 p-0">
              <KTImageInput
                fullWidth={true}
                aspectRatio={'1'}
                name="avatar"
                editable={true}
                value={Utils.isValid(avatar) ? Utils.getFullUrl(avatar) : null}
                acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                defaultImage={AppResource.icons.avatar.default}
                enableCheckValid
                onSelectedFile={(file) => {
                  setAvatarFile(file);
                  const imageUrl = URL.createObjectURL(file);
                  setAvatar(imageUrl);
                }}
                onRemovedFile={() => {
                  setAvatarFile(null);
                  setAvatar('');
                }}
              />
            </div>
            <div className='p-0'>
              Định dạng: JPG, PNG, JPEG
            </div>
          </div>
        </div>
        {/* fullname */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Họ và tên', true)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập họ và tên"
            name="fullname"
            value={fullname}
            onChange={(value) => {
              setFullname(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(fullname)}
            isTouched={readyToValidate}
            feedbackText="Họ và tên không hợp lệ"
          />
        </div>
        {/* email */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Email', true)}
          <KTFormInput
            type={KTFormInputType.email}
            placeholder="Nhập email"
            name="email"
            value={email}
            onChange={(value) => {
              setEmail(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={Utils.isValid(email) && email.match(AppConfigs.regex.email)}
            isTouched={readyToValidate}
            disabled={!!item}
            feedbackText="Email không hợp lệ"
          />
        </div>
        {/* phone */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Số điện thoại')}
          <KTFormInput
            type={KTFormInputType.telephone}
            placeholder="Nhập số điện thoại"
            name="phone"
            value={phone}
            onChange={(value) => {
              setPhone(value);
            }}
            enableCheckValid={readyToValidate}
            isValid={
              !Utils.isValid(phone) || (Utils.isValid(phone) && phone.match(AppConfigs.regex.phone))
            }
            isTouched={readyToValidate}
            feedbackText="Số điện thoại không hợp lệ"
          />
        </div>
        {/* idCard */}
        <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Số CCCD')}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập số CCCD"
            name="idCard"
            value={idCard}
            maxLength={12}
            onChange={(value) => {
              setIdCard(value);
            }}
            checkValidInput={(value) => value === '' || /^[0-9]{0,12}$/.test(value)}
            enableCheckValid={readyToValidate}
            isValid={isValidIdCard}
            isTouched={readyToValidate}
            feedbackText="Số CCCD phải gồm đúng 12 số"
          />
        </div>
        {/* password */}
        {/* <div className="col-md-6 mb-4 px-2">
          {UIHelper.buildFormLabel('Mật khẩu', !editMode)}
          <KTFormInput
            type={KTFormInputType.text}
            placeholder="Nhập mật khẩu"
            name="password"
            value={password}
            onChange={(value) => {
              setPassword(value);
            }}
            enableCheckValid={readyToValidate && !editMode}
            isValid={Utils.isValid(password)}
            isTouched={readyToValidate}
          />
        </div> */}
        {/* discountType */}
        <div className="col-md-6 mb-4 px-2">
          <div className='d-flex gap-2'>
            {UIHelper.buildFormLabel('Loại giá sạc', true, false)}
            <KTTooltip
              text={`<div>Giá sạc được áp dụng cho khách hàng mỗi lần sạc xe.</div>`}
              textHeader="Loại giá sạc"
              isHtmlContent
            >
              <i
                className="fa-regular fa-info-circle"
                style={{ color: AppColors.info }}
              />
            </KTTooltip>
          </div>
          <KTBSDropdown
            toggleElement={({ showError }) => (
              <button
                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeDriverPricingTypeOptions,
                  (item) => item.value === discountType
                )?.name ?? 'Chọn loại giá sạc'}
              </button>
            )}
            selectedValue={discountType}
            dropdownMenuItems={ChargeHelper.Data.chargeDriverPricingTypeOptions}
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            dropdownMenuClassName="overflow-auto w-100"
            onChange={(value) => setDiscountType(value)}
            enableCheckValid
            isDropdownForm={true}
          />
        </div>
        {/* discountRate */}
        {discountType === 'DISCOUNT' && (
          <div className="col-md-6 mb-4 px-2">
            {UIHelper.buildFormLabel('Tỷ lệ chiết khấu', true)}
            <KTFormInput
              type={KTFormInputType.number}
              placeholder="Nhập tỷ lệ chiết khấu"
              name="discountRate"
              value={discountRate}
              unit='%'
              onChange={(value) => {
                setDiscountRate(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={
                discountRate > 0 && discountRate < 100
              }
              checkValidInput={(value) => {
                return value === '' || /^\d+(\.\d{0,1})?$/.test(value)
              }}
              isTouched={readyToValidate}
              feedbackText={discountType === 'DISCOUNT'
                ? discountRate <= 0
                  ? 'Tỷ lệ chiết khấu phải lớn hơn 0%'
                  : discountRate >= 100
                    ? 'Tỷ lệ chiết khấu phải nhỏ hơn 100%'
                    : ''
                : ''}
            />
          </div>
        )}
      </div>
      {/* actions */}
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          handleSubmit,
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogDriverAddView;
